exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#liste_entreprise td[data-v-f75571ae]{\n  vertical-align: middle;\n}\n#collapseButton button[data-v-f75571ae]{\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n}\n#collapseButton button[data-v-f75571ae]:hover{\n  background-color: #DDDDFF;\n}\n", ""]);

// exports
